export const LOCATION_START = 'location/location-start';
export const LOCATION_SUCCESS = 'location/location-success';
export const LOCATION_ERROR = 'location/location-error';
